<template>
  <div class="modal-mask" v-bind="$attrs">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <div class="modal-title">
            <p v-if="$slots.subheader" class="subheader">
              <slot name="subheader"></slot>
            </p>
            <h1 v-if="$slots.header" class="header">
              <slot name="header"></slot>
            </h1>
            <p v-if="$slots.postheader" class="postheader">
              <slot name="postheader"></slot>
            </p>
            <!-- <slot v-else name="header"></slot> -->
          </div>
          <a v-if="closeBtn" href="" class="close-btn" aria-label="Close" @click.prevent="$emit('close')">
            <img src="@/assets/images/modal-close.png" alt="Close modal button" />
          </a>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-footer">
          <slot name="footer"> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    closeBtn: {
      type: Boolean,
      default: true,
    },
  },
  name: "Modal",
  beforeMount() {
    // When displaying a modal we tell the body that we don't
    // want the background to scroll
    const body = document.querySelector("body");
    if (body) {
      body.style.overflow = "hidden";
    }
  },
  beforeUnmount() {
    // Right before we exit the modal we tell the body to perform as it did before
    const body = document.querySelector("body");
    if (body) {
      body.style.overflow = "visible";
    }
  },
});
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  // max-width: 65%;
  // min-width: 65%;
  max-width: 50%;
  margin: 0px auto;
  padding: 0;
  background-color: #fff;
  border-radius: 0.6rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  max-height: 40%;
}

.modal-header {
  width: 100%;
  border-bottom: 0;
  padding: 0;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  display: flex;
  justify-content: space-between;
  // border: 1px solid var(--theme-color);
}

.modal-header .modal-title {
  margin-top: 0;
  padding: 1.563rem 1.5rem;
  width: 100%;
  font-family: var(--header-font);
  font-weight: 600;
  font-size: 30px;
  line-height: 24px;
}

.subheader,
.postheader {
  color: #767676;
  text-transform: uppercase;
  margin: 0;
}

h1 {
  margin: 0;
  line-height: 1;
}

.modal-header .close-btn {
  margin: 0 0 -1rem auto;
  padding: 1rem;
}

.modal-header .close-btn img {
  height: 18px;
  width: 18px;
}

/* .modal-header .close-btn:before {
  background: url("~@/assets/images/close-dark.png") no-repeat center;
  background-size: contain;
  display: inline-block;
  content: "";
  height: 0.894rem;
  width: 0.825rem;
  z-index: 3;
} */

.modal-body {
  margin: 0;
  padding: 0;
  // min-height: 300px;
  max-height: 800px; /* need for the loan config modal heights */
  overflow-y: hidden;
  overflow-x: hidden;
}

.modal-footer {
  border-top: none;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

@media (max-width: 992px) {
  .modal-container {
    max-width: 75%;
    max-height: 95%;
  }

  .modal-body {
  }
}
// Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575px) {
  .modal-container {
    min-width: -webkit-fill-available;
    max-width: 200px;
  }
  .modal-body {
    min-width: -webkit-fill-available;
    overflow-x: auto;
  }
}
</style>
